import script from "./GameFinished.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameFinished.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__